import { configureStore } from "@reduxjs/toolkit";
import callbackReducer from "./features/callbackSlice";
import estimateReducer from "./features/estimateSlice";
import categoryReducer from "./features/categorySlice";
import configReducer from "./features/configSlice";
import chatReducer from "./features/chatSlice";

export const store = configureStore({
  reducer: {
    config: configReducer,
    estimate: estimateReducer,
    category: categoryReducer,
    callback: callbackReducer,
    chat: chatReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
